import { expertise, valueColors, valueTextColors } from '../../../lookups'
import { Body, Box } from '../../widgets'
const reversed = expertise.slice().reverse()

export const Legend = ({ id }) => (
  <Box position="absolute" bottom={80} left={80} zIndex={10} column gap={9} id={id} opacity={0}>
    {reversed.map((x, index) => (
      <Box background={valueColors[valueColors .length - index - 1]} key={index} p="8px 32px" width={263} radius={9999}>
        <Body alt weight={600} size={18} color={valueTextColors[valueTextColors .length - index - 1]}>{x.toUpperCase()}</Body>
      </Box>
    ))}
  </Box>
)